<div class="container">
  <a class="dismiss" (click)="onDismiss()">
    <u-icon class="close-button" id="notification-close" [model]="{ type: 'font', value: 'icon-times-large' }"></u-icon>
  </a>
  <u-icon class="icon" [model]="{ type: 'img', value: { lightUrl: '/assets/update-available.svg' } }"></u-icon>
  <p class="title">Unleash for Apple Silicon!</p>
  <p class="subtitle">Your Mac is running on Apple Silicon, for the best experience please upgrade to the latest version.</p>
  <u-button label="Upgrade Now" type="primary" [styles]="{ width: '256px' }" class="button" (onClick)="upgrade()"></u-button>
</div>
